<script lang="ts">
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import type { PagedResponseOfLocationListEntry } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";

    export let networkId: string;
    let searchString: string;
    let searchResult: {
        name: null | PagedResponseOfLocationListEntry;
        addressLine1: null | PagedResponseOfLocationListEntry;
        city: null | PagedResponseOfLocationListEntry;
        postalCode: null | PagedResponseOfLocationListEntry;
    } = {
        name: null,
        addressLine1: null,
        city: null,
        postalCode: null,
    };
    let delayTimer: number;
    let isLoading = false;

    const navigate = useNavigate();

    const getNetwork = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.getNetwork({ networkId: networkId })
                .then((network) =>
                    networkStore.update((networkStore) => {
                        return {
                            ...networkStore,
                            network: network,
                        };
                    })
                );
        });
    };

    onMount(() => {
        getNetwork();
    });

    const searchForLocations = async () => {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(async () => {
            isLoading = true;
            searchResult = {
                name: null,
                addressLine1: null,
                city: null,
                postalCode: null,
            };
            await $user.updateToken().then(async () => {
                searchResult.name = await ApiClient.getInstance(
                    $user
                ).locationClient.searchLocations({
                    locationSearchRequest: {
                        name: searchString,
                        active: true,
                        networkId: networkId,
                    },
                });
                searchResult.addressLine1 = await ApiClient.getInstance(
                    $user
                ).locationClient.searchLocations({
                    locationSearchRequest: {
                        address: { addressLine1: searchString },
                        active: true,
                        networkId: networkId,
                    },
                });
                searchResult.city = await ApiClient.getInstance(
                    $user
                ).locationClient.searchLocations({
                    locationSearchRequest: {
                        address: { city: searchString },
                        active: true,
                        networkId: networkId,
                    },
                });
                searchResult.postalCode = await ApiClient.getInstance(
                    $user
                ).locationClient.searchLocations({
                    locationSearchRequest: {
                        address: { postalCode: searchString },
                        active: true,
                        networkId: networkId,
                    },
                });
            });
            isLoading = false;
        }, 1000);
    };
</script>

<div class="container">
    <div class="columns is-multiline">
        <div class="column is-12">
            <nav class="panel">
                <div class="panel-block">
                    <div
                        class="control has-icons-left has-icons-right {isLoading
                            ? 'is-loading'
                            : null}"
                    >
                        <input
                            class="input"
                            type="text"
                            placeholder="Standort"
                            bind:value={searchString}
                            on:input={searchForLocations}
                        />
                        <span class="icon is-left">
                            <i class="fas fa-search" />
                        </span>
                    </div>
                </div>
                {#if searchResult.name}
                    {#each searchResult.name.entries as location}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a
                            class="panel-block"
                            on:click={() => navigate(location.id)}
                        >
                            <span class="panel-icon">
                                <i class="fas fa-compass" aria-hidden="true" />
                            </span>
                            <p>
                                <b>{location.name} </b>
                                {" - " + location.address.addressLine1}, {location
                                    .address.postalCode}, {location.address
                                    .city}
                            </p>
                        </a>
                    {/each}
                {/if}
                {#if searchResult.addressLine1}
                    {#each searchResult.addressLine1.entries as location}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a
                            class="panel-block"
                            on:click={() => navigate(location.id)}
                        >
                            <span class="panel-icon">
                                <i class="fas fa-compass" aria-hidden="true" />
                            </span>
                            <p>
                                {location.name}
                                {" - "} <b>{location.address.addressLine1}</b>, {location
                                    .address.postalCode}, {location.address
                                    .city}
                            </p>
                        </a>
                    {/each}
                {/if}
                {#if searchResult.postalCode}
                    {#each searchResult.postalCode.entries as location}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a
                            class="panel-block"
                            on:click={() => navigate(location.id)}
                        >
                            <span class="panel-icon">
                                <i class="fas fa-compass" aria-hidden="true" />
                            </span>
                            <p>
                                {location.name}
                                {" - "}
                                {location.address.addressLine1},
                                <b>{location.address.postalCode}</b>, {location
                                    .address.city}
                            </p>
                        </a>
                    {/each}
                {/if}
                {#if searchResult.city}
                    {#each searchResult.city.entries as location}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a
                            class="panel-block"
                            on:click={() => navigate(location.id)}
                        >
                            <span class="panel-icon">
                                <i class="fas fa-compass" aria-hidden="true" />
                            </span>
                            <p>
                                {location.name}
                                {" - "}
                                {location.address.addressLine1}, {location
                                    .address.postalCode},
                                <b>{location.address.city}</b>
                            </p>
                        </a>
                    {/each}
                {/if}
            </nav>
        </div>
    </div>
</div>
